<template>
  <div class="home">
    <div style="display: flex; align-items: center;">
      <div class="user-img">
        <img v-if="userInfo.image" :src="userInfo.image" alt="">
        <img v-else src="../../assets/image/user.png" alt="">
      </div>
      <div style="margin-left:20px;">
        <div class="name">{{ userInfo.nickname }}</div>
        <!-- <el-button style="width: 40px;height: 20px;">店主</el-button> -->
      </div>
    </div>
    <div class="line"></div>
    <div style="margin-top: 30px; margin-left: 20px;">
      <div class="tab-item" v-for="(item, i) in tabList" :key="i" @mouseover="selectIndex = i"
        @mouseleave="selectIndex = -1" @click="onTabItem(i)">
        <div style="display:flex; align-items: center;">
          <img :src="selectIndex == i ? item.selectIcon : item.icon" alt="">
          <div>{{ item.title }}</div>
        </div>
        <div v-if="item.title == t('personal.my_points')">{{ userInfo.pointCount }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="lay-out" @click="onLayout" @mouseover="selectIndex = 5" @mouseleave="selectIndex = -1">
      <img v-if="selectIndex == 5" src="../../assets/personal/tc2.png" alt="">
      <img v-else src="../../assets/personal/tc1.png" alt="">
      <div>{{ t('personal.logout') }}</div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import router from "@/router";
import { useRoute } from "vue-router/dist/vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from 'vue-i18n';

export default {
  name: 'PersonalIndex',
  components: {},
  setup(props, { emit }) {
    const { t } = useI18n();
    const route = useRoute();
    const menuIndex = ref(0)
    const userInfo = ref({ image: '', nickname: '', pointCount: 0 })
    const tabList = ref([])
    const selectIndex = ref(-1)
    onMounted(res => {
      menuIndex.value = parseInt(localStorage.getItem('personalMenuIndex')) || 0
      if (localStorage.userInfo) {
        userInfo.value = JSON.parse(localStorage.userInfo)
        // 根据用户信息动态设置tabList
        const baseTabList = [
          { icon: require('../../assets/personal/gz2.png'), selectIcon: require('../../assets/personal/gz1.png'), title: t('personal.my_follow') },
          { icon: require('../../assets/personal/shdz2.png'), selectIcon: require('../../assets/personal/shdz1.png'), title: t('personal.my_address') },
          { icon: require('../../assets/personal/sc2.png'), selectIcon: require('../../assets/personal/sc1.png'), title: t('personal.my_upload') },
          { icon: require('../../assets/personal/jf1.png'), selectIcon: require('../../assets/personal/jf2.png'), title: t('personal.my_points') }
        ]

        // 如果用户有创作者信息，则在开头添加"我的店铺"选项
        if (userInfo.value.creatorInfoDtoResp) {
          tabList.value = [
            { icon: require('../../assets/personal/dp2.png'), selectIcon: require('../../assets/personal/dp1.png'), title: t('personal.my_shop') },
            ...baseTabList
          ]
        } else {
          tabList.value = baseTabList
        }
      }
    })
    const changeMenu = (index) => {
      menuIndex.value = index
      localStorage.setItem('personalMenuIndex', index)
    }
    const onLayout = () => {
      ElMessageBox.confirm(
        t('personal.confirm_logout'),
        t('personal.hint'),
        {
          confirmButtonText: t('personal.confirm'),
          cancelButtonText: t('personal.cancel'),
          type: 'warning',
        }
      ).then(() => {
        emit('Layout')
      })
    }
    const onTabItem = (i) => {
      emit('onTabItem', i)
    }
    return {
      t,
      onTabItem,
      selectIndex,
      onLayout,
      userInfo,
      changeMenu,
      menuIndex,
      tabList
    }
  }
}

</script>
<style lang="scss" scoped>
.home {
  padding: 10px;

  .user-img {
    width: 50px;
    height: 50px;
    border-radius: 100px;
    background-color: #f2f2f2;

    img {
      width: 50px;
      height: 50px;
      border-radius: 100px;
    }
  }

  .name {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    color: #333333;
    margin-bottom: 5px;
  }

  .line {
    margin-top: 28px;
    width: 400px;
    height: 1px;
    background: #CCCCCC;
  }

  .tab-item {
    width: 350px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    margin-bottom: 40px;

    img {
      margin-right: 10px;
    }
  }

  .tab-item:hover {
    color: #FF5D0E;
  }

  .lay-out {
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-left: 20px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;

    img {
      margin-right: 10px;
    }
  }

  .lay-out:hover {
    color: #FF5D0E;
    cursor: pointer;
  }
}
</style>
